import React, { useState } from 'react';
import Styles from './SeguroAuto25Banner.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
function SeguroAuto25Banner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="seguro-auto-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source type="image/webp" srcSet="assets/seguro-auto-25/hero/hero-320.webp" />
                  <source type="image/jpg" srcSet="assets/seguro-auto-25/hero/hero-320.jpg" />
                  <img
                    src="assets/seguro-auto-25/hero/hero-320.jpg"
                    alt="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 320 && width <= 450 && (
                <picture>
                  <source type="image/webp" srcSet="assets/seguro-auto-25/hero/hero-450.webp" />
                  <source type="image/jpg" srcSet="assets/seguro-auto-25/hero/hero-450.jpg" />
                  <img
                    src="assets/seguro-auto-25/hero/hero-450.jpg"
                    alt="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 450 && width <= 800 && (
                <picture>
                  <source type="image/webp" srcSet="assets/seguro-auto-25/hero/hero-800.webp" />
                  <source type="image/jpg" srcSet="assets/seguro-auto-25/hero/hero-800.jpg" />
                  <img
                    src="assets/seguro-auto-25/hero/hero-800.jpg"
                    alt="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 800 && width <= 1280 && (
                <picture>
                  <source type="image/webp" srcSet="assets/seguro-auto-25/hero/hero-1280.webp" />
                  <source type="image/jpg" srcSet="assets/seguro-auto-25/hero/hero-1280.jpg" />
                  <img
                    src="assets/seguro-auto-25/hero/hero-1280.jpg"
                    alt="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source type="image/webp" srcSet="assets/seguro-auto-25/hero/hero-1360.webp" />
                  <source type="image/jpg" srcSet="assets/seguro-auto-25/hero/hero-1360.jpg" />
                  <img
                    src="assets/seguro-auto-25/hero/hero-1360.jpg"
                    alt="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
                  />
                </picture>
              )}
              {width > 1360 && (
                <picture>
                  <source type="image/webp" srcSet="assets/seguro-auto-25/hero/hero-1440.webp" />
                  <source type="image/jpg" srcSet="assets/seguro-auto-25/hero/hero-1440.jpg" />
                  <img
                    src="assets/seguro-auto-25/hero/hero-1440.jpg"
                    alt="Homem sorridente dirigindo um carro moderno, representando satisfação e segurança com seguro de automóvel da Santander Financiamentos."
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Seguro Santander Auto</h1>
              <p className="alt-text">
                Conheça nossas opções de seguros para veículos e proteção financeira.
                <br />
                Conte com opções facilitadas e especiais, além de uma contratação simples e a
                cobertura perfeita para você e sua família.
              </p>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default SeguroAuto25Banner;
